import React, {memo} from "../../../../__snowpack__/pkg/react.js";
import {Tooltip} from "../../../../__snowpack__/pkg/antd.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import Hot from "../../SvgIcon/Hot.js";
import Slow from "../../SvgIcon/Slow.js";
import NewItem from "../../SvgIcon/NewItem.js";
import {Tip} from "../../Tip/index.js";
var ActivityType;
(function(ActivityType2) {
  ActivityType2["HOT"] = "HOT";
  ActivityType2["POPULAR"] = "POPULAR";
  ActivityType2["FLAT"] = "FLAT";
  ActivityType2["SLOW_SELLING"] = "SLOW_SELLING";
  ActivityType2["NEW_ITEM"] = "NEW";
})(ActivityType || (ActivityType = {}));
const HotComponent = (props) => {
  return /* @__PURE__ */ React.createElement(Hot, {
    ...props
  });
};
const index = memo(() => {
  const {formatMessage} = useIntl();
  return /* @__PURE__ */ React.createElement(Container, {
    className: "activity-wrapper"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "tip"
  }, formatMessage({id: "productActivity"})), /* @__PURE__ */ React.createElement(Tip, {
    style: {
      marginLeft: 4,
      fontSize: "16px"
    },
    placement: "bottom",
    tip: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(HotComponent, {
      style: {color: "#FF061C"}
    }), /* @__PURE__ */ React.createElement("span", {
      className: "text"
    }, formatMessage({id: "bestSellingItem"}))), /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(HotComponent, {
      style: {color: "#FF6C40"}
    }), /* @__PURE__ */ React.createElement("span", {
      className: "text"
    }, formatMessage({id: "trendingItem"}))), /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(HotComponent, {
      style: {color: "#FFAB5C"}
    }), /* @__PURE__ */ React.createElement("span", {
      className: "text"
    }, formatMessage({id: "normalItem"}))), /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Slow, null), /* @__PURE__ */ React.createElement("span", {
      className: "text"
    }, formatMessage({id: "lowSellingItem"}))), /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(NewItem, null), /* @__PURE__ */ React.createElement("span", {
      className: "text"
    }, formatMessage({id: "newItem"}))))
  }));
});
export const ActivityList = (props) => {
  const {list = []} = props;
  const {formatMessage} = useIntl();
  const productActivityMap = {
    [ActivityType.HOT]: formatMessage({id: "bestSellingItem"}),
    [ActivityType.POPULAR]: formatMessage({id: "trendingItem"}),
    [ActivityType.FLAT]: formatMessage({id: "normalItem"}),
    [ActivityType.SLOW_SELLING]: formatMessage({id: "lowSellingItem"}),
    [ActivityType.NEW_ITEM]: formatMessage({id: "newItem"})
  };
  const SvgItem = {
    [ActivityType.HOT]: /* @__PURE__ */ React.createElement(HotComponent, {
      key: "HOT",
      style: {color: "#FF061C"}
    }),
    [ActivityType.POPULAR]: /* @__PURE__ */ React.createElement(HotComponent, {
      key: "POPULAR",
      style: {color: "#FF6C40"}
    }),
    [ActivityType.FLAT]: /* @__PURE__ */ React.createElement(HotComponent, {
      key: "FLAT",
      style: {color: "#FFAB5C"}
    }),
    [ActivityType.SLOW_SELLING]: /* @__PURE__ */ React.createElement(Slow, {
      key: "SLOW_SELLING"
    }),
    [ActivityType.NEW_ITEM]: /* @__PURE__ */ React.createElement(NewItem, {
      key: "NEW"
    })
  };
  return /* @__PURE__ */ React.createElement(ActivityWrapper, null, list.map((type) => {
    return /* @__PURE__ */ React.createElement(Tooltip, {
      title: productActivityMap[type]
    }, SvgItem[type]);
  }));
};
const ActivityWrapper = styled.div`
  display: flex;
  /* align-items: center; */
  flex-wrap: wrap;
`;
const Container = styled.div`
  display: flex;
  align-items: center;
  .tip {
    color: #606c80;
  }
`;
const Wrapper = styled.div`
  font-size: 12px;
  margin-bottom: 5px;
  svg {
    width: 16px;
    height: 16px;
  }
  display: flex;
  align-items: center;
  .text {
    margin-left: 4px;
  }
`;
export default index;
